import { orderModule } from '@/api'
import { ResWrap, service, IdRequestParam } from '@/utils/request'
import {timeUtilByTimeDiff } from '@/utils/timeUtil'
/**
 * 工单类别添加编辑
 */
export interface IOrderTypeAddRequest {
  id?: number
  /**
   * 类型名
   */
  name?: string
  /**
   * 状态0停用1启动
   * */
  status?: number

  /**
   * 操作类型0手动1自动
   * */
  operateType?: number
  icon?: string
  /**
   * 字段名称 (JSON 格式)
   */
  fieldJson?: string
  /**
   * 接口地址
   */
  apiName?: string
  sort?: string
  // 所属平台
  merchantId?: string
  tenantId?: string
  language?: string
  tips?: string
}
// 工单类别列表
export interface IOrderTypeListRequest {
  pageSize?: number
  pageNum?: number
  name?: string
  merchantId?: string
  tenantId?: string
}
// 工单列表请求
export interface IOrderListRequest {
  pageSize?: number
  pageNum?: number
  id?: number
  /**
   * 类型名
   */
  name?: string
  /**
   * 状态0停用1启动
   * */
  status?: string
  operateType?: string
  merchantId?: string
  userName?: string
  auditBy?: string
  ticketsId?: string
  createTimeStart?: string
  createTimeEnd?: string
  auditTimeStart?: string
  auditTimeEnd?: string
}

export interface IOrderLockRequest {
  id?: number
  lock?: number
}
export interface IOrderAuditRequest {
  id?: number
  status?: number
  remark?: string
}
export interface OrderTypeResponse {
  id?: number
  /**
   * 类型名
   */
  name: string
  /**
   * 状态0停用1启动
   * */
  status?: string
  operateType?: string
}
export interface OrderResponse {
  userId?: number
  id?: string
  userName?: string
  ticketsId?: string
  ticketsName?: string
  createTime?: string
  auditTime?: string
  auditBy?: string
  auditId?: string
  remark?: string
  status?: string
}
/**
 * void
 *
 * Response«List«EmployeeGroupResponse»»
 */
export interface IOrderTypeResponseParam {
  /**
   * 请求返回编码
   */
  code?: string
  /**
   * 请求返回数据
   */
  data?: OrderTypeResponse[]
  /**
   * 请求返回消息
   */
  msg?: string
}
export interface IOrderResponseParam {
  /**
   * 请求返回编码
   */
  code?: string
  /**
   * 请求返回数据
   */
  data?: OrderResponse[]
  /**
   * 请求返回消息
   */
  msg?: string
}
export interface IOrderStatisticResponseParam {
  /**
   * 请求返回编码
   */
  code?: string
  /**
   * 请求返回数据
   */
  data?: OrderResponse[]
  /**
   * 请求返回消息
   */
  msg?: string
}
export interface OrderStatisticResponse {
  // count: string
  // tickets_name: string
  merchant: OrderStatisticMerchantParam[]
  type: OrderStatisticTypeParam[]
}

export interface OrderStatisticTypeParam {
  count: string
  name: string
}

export interface OrderStatisticMerchantParam {
  count: string
  operate_type: string
}
/**
 * 新增工单类别
 */
export function addUpdateOrderType(param: IOrderTypeAddRequest): Promise<ResWrap<null>> {
  return service.post(`${orderModule.orderTypeEditAddApi}`, param)
}

/**
 * 工单类别列表
 */
export function orderTypeListReq(param: any): Promise<any> {
  return service.get(
    `${orderModule.orderTypeListApi}?pageNum=${param.pageNum}&pageSize=${param.pageSize}&name=${param.name}&merchantId=${param.merchantId}&tenantId=${param.tenantId}&language=${param.language}&operateType=${param.operateType}`
  )
}
/**
 * 工单类别状态修改
 */
export function updateOrderTypeStatus(param: IOrderTypeAddRequest): Promise<ResWrap<null>> {
  return service.post(`${orderModule.orderTypeStatusApi}`, param)
}
//工单类别多选删除
export function orderTypeDelIds(param: any): Promise<ResWrap<null>> {
  return service.post(`${orderModule.orderTypeDelIds}`, param)
}

/**
 * 工单列表
 */
export function orderListReq(param: IOrderListRequest): Promise<IOrderResponseParam> {
  // return service.get(
  //   `${orderModule.orderListApi}?pageNum=${param.pageNum}&pageSize=${param.pageSize}&id=${param.id}&status=${param.status}&merchantId=${param.merchantId}&userId=${param.userId}&auditBy=${param.auditBy}&ticketsId=${param.ticketsId}
  //   &createTimeStart=${param.createTimeStart}&createTimeEnd=${param.createTimeEnd}&auditTimeStart=${param.auditTimeStart}&auditTimeEnd=${param.auditTimeEnd}`
  // )
   
   param.auditTimeStart =  timeUtilByTimeDiff(param.auditTimeStart,true)
    param.auditTimeEnd = timeUtilByTimeDiff(param.auditTimeEnd,true)

    param.createTimeStart =  timeUtilByTimeDiff(param.createTimeStart,true)
    param.createTimeEnd = timeUtilByTimeDiff(param.createTimeEnd,true)
  return service.post(`${orderModule.orderListApi}`, param)
}
// 工单解锁和锁定
export function changeLockReq(param: IOrderLockRequest): Promise<any> {
  return service.post(`${orderModule.orderStatusApi}`, param)
}
// 工单详情修改
export function orderAuditReq(param: IOrderAuditRequest): Promise<any> {
  return service.post(`${orderModule.orderAuditApi}`, param)
}
// 第三方接口查询

export function autoOrderReq(param: any): Promise<any> {
  return service.get(`${orderModule.autoOrderApi}/${param.orderId}`)
}
// 工单默认语言
export function getDefaultLanguage(param: any): Promise<any> {
  return service.get(`${orderModule.getDefaultLanguage}`)
}
// 设置工单默认语言
export function updateDefaultLanguage(param: any): Promise<any> {
  return service.post(`${orderModule.updateDefaultLanguage}`, param)
}
// 工单统计
export function orderStatistics(): Promise<any> {
  return service.get(`${orderModule.orderStatistics}`)
}

// 工单统计
export function ticketsOrder(param: any): Promise<any> {
  return service.post(`${orderModule.ticketsOrder}`, param)
}

// 刷新es
export function refreshEs(): Promise<any> {
  return service.get(`${orderModule.refreshEs}`)
}
